import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import queryString from 'query-string'
import { registerRoute, loginRoute } from "routes.jsx";


const LoginRequiredRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const query = queryString.parse(props.location.search);

        let pathname = loginRoute;
        if(query.registerId){
            pathname = registerRoute;
        } 
        /*else if(props.location.pathname === "/admin/ask"){
            pathname = "/auth/ask"
        }*/
        return (
            rest.loggedIn ? (
                <Component {...props} />
            ) : (
                    <Redirect to={{
                        pathname,
                        search: props.location.search,
                        state: { from: props.location }
                    }} />
                )
        )
    }} />
)

export default connect(
    state => ({
        loggedIn: state.login.loggedIn,
    })
)(LoginRequiredRoute);